import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import Button from 'orionsoft-parts/lib/components/Button'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import sleep from 'orionsoft-parts/lib/helpers/sleep'

@withGraphQL(
  gql`
  query faceFlowData($documentId: ID) {
      faceFlowData(documentId: $documentId)
  }
  `
)

@withMutation(gql`
  mutation queryEstadoFaceAuth($faceId: String!, $documentId: ID!) {
    queryEstadoFaceAuth(faceId: $faceId, documentId: $documentId)
  }
`)

@withMessage
@withRouter
export default class FaceData extends React.Component {
  state = {
  }

  static propTypes = {
    showMessage: PropTypes.func,
    queryEstadoFaceAuth: PropTypes.func,
    document: PropTypes.object,
    faceFlowData: PropTypes.object,
    router: PropTypes.object,
    params: PropTypes.object,
    url: PropTypes.bool
  }

  gotoProfile(mensaje) {
    if (mensaje) { this.props.showMessage(mensaje) }
    setTimeout(() => {
      this.props.router.push(`/settings`)
    }, 5000
    )
  }

  renderFaceFlowData() {
    // console.log("faceFlowData", this.props.faceFlowData);
    localStorage.setItem('active', true)
    localStorage.setItem('docId', this.props.document._id)
    localStorage.setItem('docLink', window.location.href.split('?')[0].split('#')[0])
    if(this.props.faceFlowData){
      if(this.props.faceFlowData.estado === -100){
        setTimeout(() => {
          this.props.router.push(`/settings`)
        }, 5000
        )
        return (

          <div className={styles.btnHeader}>
            <Button
              className={styles.btnCancelar}
              primary
              loading={this.state.loading}>
                 Para completar flujo facial debe completar su RUT y teléfono en su perfil
            </Button>
          </div>

        )
        //this.props.showMessage('Para compeltar flujo facial debe completar su perfil');
        
      } else if(this.props.faceFlowData.estado === 0) {
        let imgSrc = 'data:image/jpeg;base64,' + this.props.faceFlowData.qrCode;
        if(!this.checkeandoFaceAuth){
          console.log("NO estoy consultando, inicio consulta");
          this.checkFaceAuth();
        }
        
          
        return (
          <div>
            <div className="col-xs-12 start-md">
              <div className={styles.btnHeader}>
                <div className={styles.instructions}>
                  <img src="/face-scanner.png" alt="https://www.flaticon.com/free-icons/digitalisation"/>
                  <p>Acá deben ir las instrucciones preliminares. Algún mono bonito de una cara, ocupar todo el espacio y centrado el QR.
            Se debe decir que no se cierre la pagina DURANTE la validacion facial</p>
                </div>
              </div>
              <div className={`col-xs-12 center-md ${styles.large}`}>
                <p>
                  <b>Escanee el siguiente código en su dispositivo móvil para realizar la autenticación facial
                    <br/>
              NO CERRAR LA VENTANA sino hasta finalizar el proceso.
                  </b>
                </p>
              </div>
              <div className='col-xs-12 center-md qr'>
                <img src={imgSrc}/>
              </div>
              <a href={this.props.faceFlowData.url}>O haciendo click acá en tú móvil</a>
              
            </div>
          </div>
        )
      } else if (this.props.faceFlowData.estado === 1) {
        console.log('faceFlowRealizdo!')
        return null
      }
    }
  }

  checkeandoFaceAuth = false;
  async checkFaceAuth(){
    this.checkeandoFaceAuth=true;
    await sleep(7000);
    if(this.state.pageClosed){ 
      return;
    }
    console.log("----- Consultando estado de autorizaion facial");
    let consultaEStadoAuth = await this.props.queryEstadoFaceAuth({
      faceId: this.props.faceFlowData.id,
      documentId: this.props.document._id
    })
    console.log('Estado es ', consultaEStadoAuth.queryEstadoFaceAuth)
    if (consultaEStadoAuth.queryEstadoFaceAuth.estado === -100) {
      console.log('Sin profile!')
      this.gotoProfile('Debe completar su perfil para usar flujo facial')
      return
    } else if (consultaEStadoAuth.queryEstadoFaceAuth.estado === -200) {
      console.log('Reiniciar!')
      window.location.reload()
      return
    } if (consultaEStadoAuth.queryEstadoFaceAuth.estado === 1) {
      console.log('Autoprizacion realizada!')
      window.location.reload()
    }
    this.checkFaceAuth()
  }

componentWillUnmount() {
    this.state.pageClosed =  1;
}
 
componentDidMount(){
  
}

  render() {

    return (
      <div className={styles.container}>
        <div className="content">
          <div className="row">
            {this.renderFaceFlowData()}
          </div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/Status/Title/FaceData/index.js